/* globals ProgressButton:true */

import {Input} from 'malt-joy/src/js/form/Input';
import {Counter} from 'malt-joy/src/js/form/Counter';
import {initTooltip} from './initTooltip';
import {FakeInputDate} from './components/fakeInputDate';

function checkInputDateNumber(type) {
    const input = document.createElement('input');
    const notADateValue = 'not-a-date-and-number';

    input.setAttribute('type', type);
    return !(input.value === notADateValue);
}

Hop.supportFn = Hop.supportFn || {};

Hop.supportFn.checkInputDateNumber = checkInputDateNumber;

function isValueTrue($checkboxOrYetUnhandledElements) {
    if ($checkboxOrYetUnhandledElements.is('input[type="checkbox"]')) {
        return $checkboxOrYetUnhandledElements[0].checked;
    }
    return false;
}

Hop.defineModule('forms', (root, param = {}) => {
    const domForm = root.nodeName === 'FORM' ? root : root.querySelector('form');
    const $form = $(domForm);

    Hop.formFn = {};

    let requestAnim;
    let noanimation = false;
    let listenerChangeOn = false;
    const $allFields =
        checkInputDateNumber('date') && !param.datemasked
            ? $form.find('input, select, textarea')
            : $form.find('input, select, textarea').not('[type=date]');

    $form.find('[data-required-if-true]').each((i, el) => {
        const $toggleElements = $($(el).data('requiredIfTrue'));

        function makeItRequiredIfTrue() {
            el.required = isValueTrue($toggleElements);
        }

        el.required = makeItRequiredIfTrue();
        $toggleElements.change(makeItRequiredIfTrue);
    });

    initTooltip($allFields, param.noTooltips);

    Hop.events.on('initElementTooltip', initTooltip);

    Hop.formFn.initPosTooltip = function (oTooltip, tooltip, $target, $field) {
        if (matchMedia('(min-width: 768px)').matches) {
            const pos = oTooltip.getPosition($target);
            const $tooltip = $(tooltip);
            const marge = $target.is('label') ? 5 : 10;
            const dataTarget = $.data($field[0], 'pos');

            setTimeout(() => {
                if (dataTarget.placement === 'right' && matchMedia('(min-width: 992px)').matches) {
                    $tooltip.css({
                        'margin-left': $field.hasClass('editable-tag-input') ? 10 : marge,
                    });
                } else if (dataTarget.placement === 'left' && matchMedia('(min-width: 992px)').matches) {
                    $tooltip.css({
                        'margin-right': $field.hasClass('editable-tag-input') ? 10 : marge,
                    });
                } else {
                    $tooltip.css({
                        top: dataTarget.placement === 'bottom' ? dataTarget.top + marge : dataTarget.top - $tooltip.height() - marge,
                        left: pos.left - $tooltip.width() / 2 + pos.width / 2,
                    });
                }
            }, 1);
        }
    };

    function isJoyV2DatePicker(input) {
        return input.parentNode && input.parentNode.classList.contains('m-input_date');
    }

    if (!checkInputDateNumber('date') || (param.datemasked && !Hop.getBrowserDesc().mobile)) {
        domForm.querySelectorAll('input[type=date]').forEach((domInput) => {
            if (!isJoyV2DatePicker(domInput)) {
                if (!domInput.classList.contains('date-picker') && !domInput.classList.contains('fakeDateInit')) {
                    if (Hop.FormCalendar) {
                        Hop.getStoreObj(domInput.getAttribute('id')) === undefined && Hop.storeObj(new FakeInputDate(domInput, param.calendar));
                    } else {
                        new FakeInputDate(domInput, param.calendar);
                    }
                }
            }
        });

        domForm.querySelectorAll('input[data-typeDate=true]').forEach((domInput) => {
            if (!isJoyV2DatePicker(domInput)) {
                setMaskInputPattern(domInput);
            }
        });
    } else {
        $form.find('input[type=date]').each((idx, el) => {
            const $input = $(el);
            // Ignore joy-v2 datepicker.
            if (!isJoyV2DatePicker(el)) {
                $input.removeAttr('pattern');
                $input.wrap('<span class="w-add-on-left"/>');
                $input.parent().append('<i class="fa fa-calendar add-on"/>');
            }
        });
    }

    function intervalButtonAnim(instance) {
        let progress = 0;
        instance.interval = setInterval(() => {
            progress = Math.min(progress + Math.random() * 0.1, 1);
            instance._setProgress(progress);

            if (progress === 1) {
                if (instance.ajax) {
                    progress = 0;
                } else {
                    instance._stop(1);
                    clearInterval(instance.interval);
                }
            }
        }, 200);
    }

    Hop.formFn.intervalButtonAnim = intervalButtonAnim;

    function setMaskInputPattern(el) {
        if ($.mask) {
            if (el.hasAttribute('data-mask')) {
                $(el).mask(el.getAttribute('data-mask'));
            } else {
                $(el).mask('99/99/9999');
            }
        }
    }

    Hop.formFn.setMaskInputPattern = setMaskInputPattern;

    $.fn.commapoint = function () {
        if ($(this).attr('type') === 'text' || !checkInputDateNumber('number')) {
            $(this).on('keyup', (e) => {
                const $this = $(e.currentTarget);
                const key = e.keyCode || e.which;
                // '188' is the keyCode for ','
                if (key === 188) {
                    // Cancel the keypress
                    e.preventDefault();
                    // Add the comma to the value of the input field
                    $this.val($this.val().replace(',', '.'));
                    $this.change();
                }
            });
            return this;
        } else {
            $(this).removeAttr('pattern');
        }
    };

    $form.find("input[data-type='number']").commapoint();

    Hop.formFn.updateAutogrow = (selector) => {
        function normalizedTargets(givenSelector) {
            if (givenSelector instanceof jQuery) {
                return givenSelector;
            }

            return $(givenSelector);
        }

        if ($.fn.autogrow) {
            normalizedTargets(selector).each((idx, el) => {
                $(el).css('overflow', 'hidden').autogrow();
            });
        }
    };

    if (param !== undefined) {
        if (param.stopenter !== undefined) {
            $form.on('keypress', (e) => {
                const key = e.keyCode || e.which;
                if (key === 13 && !$(e.target).is('textarea')) {
                    e.preventDefault();
                }
            });
        }

        if (param.autogrow !== undefined) {
            Hop.formFn.updateAutogrow(param.autogrow.target);
        }

        if (param.progressbtn !== undefined && window.ProgressButton) {
            /**
             * [description]
             * To work progress button you need to put on link/button this attributes :
             * and if it's ajax action, add this attribute "data-ajax"
             */
            $form.find('.progress-button').each((idx, el) => {
                /*
                 * Store js object with an id
                 */

                $form.on('invalidform validform', (e) => {
                    if (param.progressbtn.control === undefined || param.progressbtn.control === true) {
                        // 'keydown' and 'click' events finally trigger a submit event on the form.
                        // Since the 'keydown' event is erroneously sent to the form when using auto-
                        // completion, let's ignore it and rely on the 'submit' event.
                        if (e.evt.type !== 'keydown') {
                            Hop.getStoreObj($(e.target).find('[type=submit]').attr('id'))._stop(e.type === 'invalidform' ? -1 : 1);
                        }
                    } else {
                        // And what we do when it's valid ?
                        if (e.type === 'invalidform') {
                            Hop.getStoreObj($(e.target).find('[type=submit]').attr('id'))._stop(-1);
                        }
                    }
                });

                const progressButton = new ProgressButton(el, {
                    callback: (instance) => {
                        intervalButtonAnim(instance);
                    },
                });

                const id = el.getAttribute('id');

                Hop.storeObj(progressButton, id);
            });
        }

        if (param.autotrim) {
            $form.find("[data-autotrim='true']").blur((e) => {
                const el = e.currentTarget;
                el.value = $.trim(el.value);
            });
        }

        if (param.autormspaces) {
            $form.find("[data-autormspaces='true']").blur((e) => {
                const el = e.currentTarget;
                el.value = el.value.replace(/ /g, '');
            });
        }
    }

    function resetInvalidForm($form) {
        if (!$form[0]) {
            return;
        }

        const firstInvalidField = $form[0].querySelector(':invalid');
        if (!firstInvalidField) {
            $form.removeClass('invalid');
        }

        $form[0].querySelectorAll(':valid').forEach((f) => f.setAttribute('aria-invalid', false));
    }

    Hop.formFn.resetInvalidForm = resetInvalidForm;

    function getErrorMessageId(fieldId) {
        return `erro-${fieldId}`;
    }

    function getErrorMessageSelector(fieldId) {
        return `#${getErrorMessageId(fieldId)}`;
    }

    function removeMessage(sync = false) {
        removeMessageBySelector('.error-message', sync);
    }

    function removeSingleMessage(fieldId, sync = false) {
        removeMessageBySelector(getErrorMessageSelector(fieldId), sync);
    }

    function removeMessageBySelector(selector, sync) {
        $(selector).each((idx, el) => {
            const $this = $(el);

            function remove() {
                $this.off().remove();
            }

            if (matchMedia('(max-width: 480px)').matches) {
                cancelAnimationFrame(requestAnim);
            }

            $this.removeClass('open');

            if (sync) {
                remove();
            } else {
                setTimeout(remove, 500);
            }
        });
    }

    Hop.formFn.removeMessage = removeMessage;
    Hop.formFn.removeSingleMessage = removeSingleMessage;

    function getJsonErrorMessage(data) {
        data = data.replace(/'/g, '"');
        return JSON.parse(data);
    }

    function matchPattern(el) {
        const pattern = new RegExp('^' + el.getAttribute('pattern').replace('^^|$$') + '$', 'g');
        return el.value.match(pattern);
    }

    Hop.formFn.getJsonErrorMessage = getJsonErrorMessage;

    function checkPatternError($form) {
        const $elPatterns = $form.find('[pattern]');
        let elPattern;
        let dataAtt;
        for (let i = 0; i < $elPatterns.length; i++) {
            elPattern = $elPatterns[i];
            dataAtt = elPattern.getAttribute('data-errormessage');
            if (dataAtt !== null && dataAtt !== '' && elPattern.value !== '') {
                if (matchPattern(elPattern)) {
                    elPattern.setCustomValidity('');
                } else {
                    if (elPattern.value === '') {
                        elPattern.setCustomValidity(getJsonErrorMessage(elPattern.getAttribute('data-errormessage')).valueMissing);
                    } else {
                        elPattern.setCustomValidity(getJsonErrorMessage(elPattern.getAttribute('data-errormessage')).patternMismatch);
                    }
                }
            }
        }
    }

    function addMessage($form) {
        if (!$form.length) {
            return;
        }

        noanimation = false;

        checkPatternError($form);

        const invalidFields = $(Array.from($form[0].querySelectorAll(':invalid'))).not('fieldset');
        let $field;
        let pos;
        let height;
        let $bubble;
        let reqFrame;

        let bubbleArrowClass;
        let validationMessage;

        function setBubblePosition() {
            pos = $field.offset();
            height = $field.innerHeight();

            if (param.errorPlacement === 'bottom') {
                pos.top -= height * 2;
            } else {
                pos.top += height;
            }

            $bubble.css({
                top: pos.top,
                left: pos.left,
            });

            if ($bubble.hasClass('open')) {
                requestAnimationFrame(setBubblePosition);
            } else {
                cancelAnimationFrame(reqFrame);
            }
        }

        function getBubble($field) {
            const fieldId = $field.attr('id');

            // Be careful, do not stack bubble error message, use existing one if it exists.
            let $bubble = $(getErrorMessageSelector(fieldId));
            if (!$bubble.length) {
                $bubble = $(
                    '<div id="' +
                        getErrorMessageId(fieldId) +
                        '" class="error-message"><div class="' +
                        bubbleArrowClass +
                        '"></div>' +
                        validationMessage +
                        '</div>',
                );
                $('body').append($bubble);
            }

            return $bubble;
        }

        resetInvalidForm($form);

        if (invalidFields.length) {
            for (let i = 0; i < invalidFields.length; i++) {
                invalidFields[i].lastValue = invalidFields[i].value;
            }

            invalidFields.attr('aria-invalid', 'true');
            invalidFields.closest('fieldset').addClass('invalid');
            invalidFields.closest('.form-field,.material-input,.f-input-number').addClass('invalid');

            $field = invalidFields.eq(0);

            bubbleArrowClass = param.errorPlacement === 'bottom' ? 'error-message__arrow bottom' : 'error-message__arrow';

            validationMessage = $field.attr('data-validation-message') || $field[0].validationMessage;

            $bubble = getBubble($field);

            updateAriaAlert(validationMessage);

            setTimeout(() => {
                reqFrame = requestAnimationFrame(setBubblePosition);
                $bubble.addClass('open');
                setTimeout(() => {
                    noanimation = true;
                    if (matchMedia('(max-width: 480px)').matches) {
                        keepMessagePosition();
                    }
                }, 2000);
            }, 100);

            if (!$form.hasClass('invalid')) {
                $form.addClass('invalid');
            }

            // If there are errors, give focus to the first invalid field
            invalidFields.on('blur keyup', (e) => {
                if (e.target.type !== 'checkbox' && e.target.type !== 'radio') {
                    e.currentTarget.setCustomValidity('');
                }
            });

            scrollToErroredField(invalidFields[0], $form[0]);

            invalidFields.eq(0).on('blur keyup', (e) => {
                if (e.which !== 13) {
                    Hop.formFn.removeMessage(true);
                    const el = e.currentTarget;
                    if (el.type !== 'date') {
                        $(el).off('blur keyup');
                    }
                }
            });

            if (!listenerChangeOn) {
                $form.on('change', () => Hop.formFn.resetInvalidForm($form));
                listenerChangeOn = true;
            }
        }

        // fix message position when mobile zoom and move screen
        function keepMessagePosition() {
            requestAnim = requestAnimationFrame(keepMessagePosition);
            $bubble.css('top', $field.offset().top + height);
        }
    }

    /**
     * The current target for the error auto-scrolling.
     * It is used to not stack autoscroll on the same element.
     */
    let currentScrollToElement;

    /**
     *
     * scrollToErroredField() ensure :
     - show to the user the right errored field (even sr-only checkboxes, showing associated label)
     - scrolling smoothly to the errored field
     *
     * @param {HTMLElement} field The field.
     * @param {HTMLElement} form The form containing the field.
     */
    function scrollToErroredField(field, form) {
        if (window.HopFlags && window.HopFlags.animationsProfile !== 'full') {
            field.focus();
            return;
        }

        function rightDomElement(field) {
            if (field.getAttribute('type') === 'checkbox' || field.getAttribute('type') === 'radio') {
                return form.querySelector('[for="' + field.getAttribute('id') + '"]');
            } else {
                return field;
            }
        }

        const el = rightDomElement(field);
        if (!currentScrollToElement || currentScrollToElement !== el) {
            currentScrollToElement = el;

            Hop.scrollToTarget(el, (target) => {
                if (currentScrollToElement && target === currentScrollToElement) {
                    currentScrollToElement.focus();
                    currentScrollToElement = null;
                }
            });
        }
    }

    Hop.formFn.addMessage = addMessage;

    function updateAriaAlert(msg) {
        let alert = $('#alert');
        if (!alert.length) {
            $('body').append('<div role="alert" id="alert" class="sr-only" aria-live="assertive" ></div>');
            alert = $('#alert');
        }
        alert.text(msg);
    }

    Hop.formFn.updateAriaAlert = updateAriaAlert;

    function checkValidity(el) {
        return typeof el.checkValidity !== 'function' || el.checkValidity();
    }

    function shouldSkip(el) {
        return el.getAttribute('name') === 'socialButton';
    }

    function testValidForm(form, event) {
        $(form).trigger({type: 'testValidForm', evt: event});

        if (!shouldSkip(event.target)) {
            if (!checkCaptcha() || !checkValidity(form)) {
                $(form).trigger({type: 'invalidform', evt: event});
                if (event.preventDefault) {
                    event.preventDefault();
                } else {
                    event.returnValue = false;
                }
            } else {
                $(form).trigger({type: 'validform', evt: event});
                resetInvalidForm($(form));
            }
            addMessage($(form));
        }
    }

    function testValidSubForm(el) {
        const $el = $(el);
        const inputs = $el.find('input');

        let isValid = true;
        for (let i = 0, size = inputs.length; i < size; ++i) {
            const input = inputs[i];
            if (!shouldSkip(input) && !checkValidity(input)) {
                isValid = false;
                break;
            }
        }

        if (!isValid) {
            addMessage($el);
        }

        return isValid;
    }

    Hop.formFn.testValidForm = testValidForm;
    Hop.formFn.testValidSubForm = testValidSubForm;

    function testBlocForm($content) {
        $form.trigger('testBlocForm');

        return !($content[0] && !!$content[0].querySelector(':invalid'));
    }

    Hop.formFn.testBlocForm = testBlocForm;

    function replaceValidationUI(form) {
        // Suppress the default bubbles

        if (form.addEventListener) {
            form.addEventListener(
                'invalid',
                (event) => {
                    event.preventDefault();
                },
                true,
            );
        }

        const $form = $(form);

        $(document).on('click', (e) => {
            if (!noanimation) {
                return;
            }

            const target = e.target;
            const isSubmitBtn = target.type === 'submit';

            // Check the parent, since target may be an icon in a button.
            const parent = target.parentNode;
            const isParentSubmitBtn = parent && parent.type === 'submit';

            if (!isSubmitBtn && !isParentSubmitBtn) {
                removeMessage(true);
            }
        });

        if (!param.preventAutoValidation) {
            const eventForm = param.hiddenform ? 'control' : 'keydown submit control';

            $form.on(eventForm, (event) => {
                const type = event.type;
                const which = event.which;
                const targetType = event.target.type;

                // If the current active element has specifically a `formnovalidate` attribute,
                // then it means that the entire form should not be validated.
                // Note that the active element means the element currently being focused, so
                // it may not exist if the form was submitted programmatically for example.
                // See: https://developer.mozilla.org/fr/docs/Web/HTML/Element/button
                const activeElement = document.activeElement;
                const noValidate = !activeElement || activeElement.formNoValidate;
                if (
                    !noValidate &&
                    (type === 'submit' || type === 'control' || (which === 13 && targetType !== 'textarea' && !param.preventFormSubmitOnEnter))
                ) {
                    testValidForm(event.currentTarget, event);
                }
            });

            if (!param.hiddenform) {
                $form.on('click', 'button[type=submit]', (event) => {
                    const currentTarget = event.currentTarget;

                    // If the button being clicked has specifically a `formnovalidate` attribute,
                    // then it means that the entire form should not be validated.
                    // See: https://developer.mozilla.org/fr/docs/Web/HTML/Element/button
                    if (!currentTarget.formNoValidate) {
                        testValidForm($(currentTarget).parents('form')[0], event);
                    }
                });
            }
        } // else: another script should be in charge to call testValidForm
    }

    // Replace the validation UI for all forms
    replaceValidationUI($form[0]);

    function setErrorServerFiels(list) {
        if (!list) {
            return;
        }
        list.forEach((errorField) => {
            const field = $form[0].querySelector('[name="' + errorField.attribute + '"]');
            field && field.setCustomValidity(errorField.error);
        });
        $form[0].dispatchEvent(new window.CustomEvent('control', {}));
    }

    // all handlers

    $form[0].addEventListener('hopModuleTrigger', (e) => {
        if (e.detail.task === 'destroy') {
            $form.find('.fakeDateInit').each((idx, el) => {
                Hop.destroyObj(
                    $(el)
                        .parent()
                        .find('[name=fake-' + el.name + ']')
                        .attr('id'),
                );
            });
        }

        if (e.detail.task === 'errorFields') {
            setErrorServerFiels(e.detail.list);
        }
    });

    let reCaptcha;

    function checkCaptcha() {
        if (param.reCaptcha) {
            return !(typeof window.grecaptcha === 'undefined' || window.grecaptcha.getResponse(reCaptcha) === '');
        } else {
            return true;
        }
    }

    // reCAPCHAT init
    if (param.reCaptcha) {
        document.addEventListener('reCaptcha', () => {
            reCaptcha = window.grecaptcha.render(param.divCaptchaId, {
                'sitekey': '6LcC-zgUAAAAAOBKrr77TflctzvomynIpzkp8Lpo',
                'callback': () => {
                    $form[0].querySelector('button[type=submit]').disabled = false;
                    const captchaInput = $form[0].querySelector('input[name=captcha]');
                    if (captchaInput) {
                        captchaInput.value = window.grecaptcha.getResponse();
                    }
                },
                'expired-callback': () => {
                    $form[0].querySelector('button[type=submit]').disabled = true;
                },
                'theme': 'light',
            });
        });
    }

    // Material inputs
    function updateFieldState(input) {
        if (input && input.getAttribute('type') !== 'hidden') {
            const domParent = input.closest('.material-input');
            const hasValue = input.value && input.value.length;
            const hasFocus = input === document.activeElement;

            if (hasValue || hasFocus) {
                domParent.classList.add('active');
            } else {
                domParent.classList.remove('active');
            }
        }
    }

    Hop.formFn.updateMaterialInput = updateFieldState;
    Hop.formFn.setUpMaterialInputs = setUpMaterialInputsHandlers;

    function setUpMaterialInputsHandlers(container = root) {
        const materialInputs = [...container.querySelectorAll('.material-input textarea, .material-input input, .material-input select')];

        materialInputs.forEach((input) => {
            input.addEventListener('focus', (e) => updateFieldState(e.target));
            input.addEventListener('blur', (e) => updateFieldState(e.target));
            input.addEventListener('input', (e) => updateFieldState(e.target));
            input.addEventListener('keyup', (e) => updateFieldState(e.target));
            input.addEventListener('onpropertychange', (e) => updateFieldState(e.target));

            updateFieldState(input);
        });
    }

    setUpMaterialInputsHandlers();

    let submitted = false;

    function preventDuplicateSubmission() {
        $form.submit((event) => {
            if (param.preventDuplicateSubmission && submitted) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
            submitted = true;

            if (window.SIGN_UP_GTM_ENABLED && $form.attr('data-gtm-form-signup')) {
                try {
                    const gtmTrackingElement = JSON.parse($form.attr('data-gtm-form-signup'));

                    if (Array.isArray(gtmTrackingElement)) {
                        gtmTrackingElement.forEach((trackingObject) => {
                            Hop.gtm.push(trackingObject);
                        });
                    } else {
                        Hop.gtm.push(gtmTrackingElement);
                    }
                } catch (e) {
                    Hop.logError('Could not parse attribute data-gtm-form-signup of ' + Hop.describeDomElement($form[0]), e);
                }
            }

            if ($form.attr('data-gtm')) {
                try {
                    Hop.gtm.push(JSON.parse($form.attr('data-gtm')));
                } catch (e) {
                    Hop.logError('Could not parse attribute data-gtm of ' + Hop.describeDomElement($form[0]), e);
                }
            }
        });
    }

    preventDuplicateSubmission();
    importInputClass();
    initCounters();

    function importInputClass() {
        document.querySelectorAll('[data-input-container]').forEach((input) => new Input(input));
    }

    function initCounters(wrapper = root) {
        wrapper.querySelectorAll('[data-counter]').forEach((wrapper) => new Counter(wrapper));
    }

    Hop.formFn.updateCounters = (wrapper) => {
        initCounters(wrapper);
    };
});

window.onloadCallbackReCaptcha = () => {
    document.dispatchEvent(new window.CustomEvent('reCaptcha', {}));
};
